var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ad)?_c('div',{staticClass:"tile is-child ad"},[_c('a',{staticClass:"is-size-5",style:(_vm.style),attrs:{"href":_vm.ad.url,"target":"_blank","title":_vm.ad.title}},[_vm._v(" "+_vm._s(_vm.ad.title)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }